<app-nav></app-nav>
<div class="container">
  <section class="insurances-panel">
    <div class="container px-2">
      <div class="col">
        <div class=full-notification>
          <a *ngIf="notificationViewData.productUrl" href="{{notificationViewData.productUrl}}" target="_blank">
            <img src="{{notificationViewData.fileUrl}}" />
          </a>
          <img *ngIf="!notificationViewData.productUrl" src="{{notificationViewData.fileUrl}}" />
          <h5>{{notificationViewData.title}}</h5>
          <p>{{notificationViewData.message}}</p>
          <p class="date">{{notificationViewData.updated | date: 'dd-MMM-yyyy'}}</p>
        </div>
      </div>
    </div>
    <div id="spinner" [hidden]="!loading">
      <div class="spinnerfull">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
    </div>
  </section>
</div>